import { useContext } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { AuthContext } from "../services/context";
import { useGetAllFeatureFlags } from "../api/featureFlags";
import { getCurrentWorkspace } from "../services/userConfig";

function FeatureFlagRoute({ flag }) {
  const { user } = useContext(AuthContext);
  const currentWorkspace = getCurrentWorkspace(user);
  const { data: flags, isLoading } = useGetAllFeatureFlags({
    eventId: currentWorkspace?.eventId,
  });

  if (isLoading) {
    return null;
  }

  const isEnabled = flags?.find((f) => f.featureName === flag)?.enabled;

  if (!isEnabled) {
    return <Navigate to="/404" />;
  }

  return <Outlet />;
}

export default FeatureFlagRoute;
